// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../statics/modal_image_close.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModalFeedback_modal_container__F71LN {
    width: 560px;
    height: 564px;
}

.ModalFeedback_modal_container__F71LN .ant-modal-content {
    padding: 0 0 16px 0 !important;
}

/* .modal_container :global(.ant-modal-close:hover) {
    background-color: #fff;
} */

.ModalFeedback_main__ISWhI {
    width: 100%;
    height: 548px;
    padding: 65px 52px 0 52px;
}

.ModalFeedback_header__vNGIG,
.ModalFeedback_section__p21J7,
.ModalFeedback_section2__yWV8f {
    margin-bottom: 20px;
}

.ModalFeedback_header_title__OB-V\\+ {
    margin-bottom: 20px;
    font-size: 30px;
    font-weight: bold;
    color: #1F1F1F;
    text-align: center;
}

.ModalFeedback_header_explain__fbfSy {
    font-size: 14px;
    color: #1f1f1f;
}

.ModalFeedback_section_title__ZA5Xa,
.ModalFeedback_section2_title__bdWes {
    margin-bottom: 15px;
    font-weight: bold;
    font-size: 14px;
    color: #1f1f1f;
}

.ModalFeedback_section2_title__bdWes {
    margin-bottom: 5px;
}

.ModalFeedback_custom_textarea__yUPlI:hover,
.ModalFeedback_custom_textarea__yUPlI:focus-within,
.ModalFeedback_custom_textarea__yUPlI:focus {
    border-color: #17a8b5;
}

/* 自定义滚动条 */
.ModalFeedback_custom_textarea__yUPlI::-webkit-scrollbar {/*滚动条整体样式*/
    -webkit-appearance: none;
    width: 5px;
    height: 5px;
}

.ModalFeedback_custom_textarea__yUPlI::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    cursor: pointer;
    border-radius: 5px;
    background: #e9e9e9;
    -webkit-transition: color .2s ease;
    transition: color .2s ease;
}

.ModalFeedback_custom_textarea__yUPlI::-webkit-scrollbar-thumb:hover {
    background: #e3e3e3;
    cursor: default;
}

@keyframes ModalFeedback_shake__T8GOB {
    0%, 100% {
      transform: translateX(0);
    }
    10%, 30%, 50%, 70%, 90% {
      transform: translateX(-2px);
    }
    20%, 40%, 60%, 80% {
      transform: translateX(2px);
    }
}

.ModalFeedback_feel_butn_box__fuMYm {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    width: 100%;
    padding: 0 65px;
}

.ModalFeedback_feel_butn__x5Ahz {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 50px;
    cursor: pointer;
}

.ModalFeedback_feel_butn__x5Ahz:not(.ModalFeedback_selected__ZASmt):hover {
    animation: ModalFeedback_shake__T8GOB 0.82s cubic-bezier(.36,.07,.19,.97) both;
}

.ModalFeedback_feel_butn_img__eDMj\\+ {
    width: 36px;
    height: 36px;
}

.ModalFeedback_hook_img__6AGVm {
    position: absolute;
    bottom: -10px;
    right: 0;
    width: 32px;
    height: 32px;
}

.ModalFeedback_footer__Gr9FB {
    width: 100%;
    height: 48px;
}

.ModalFeedback_close_butn__P1pXX {
    width: 24px;
    height: 24px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center / 100% 100%;
}`, "",{"version":3,"sources":["webpack://./src/common/ModalFeedback/index.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;;GAEG;;AAEH;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;AAC7B;;AAEA;;;IAGI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;;IAEI,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;;IAGI,qBAAqB;AACzB;;AAEA,WAAW;AACX,0DAAqC,UAAU;IAC3C,wBAAwB;IACxB,UAAU;IACV,WAAW;AACf;;AAEA,gEAA2C,WAAW;IAClD,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IAEnB,kCAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI;MACE,wBAAwB;IAC1B;IACA;MACE,2BAA2B;IAC7B;IACA;MACE,0BAA0B;IAC5B;AACJ;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,8EAAyD;AAC7D;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,QAAQ;IACR,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gFAAmF;AACvF","sourcesContent":[".modal_container {\n    width: 560px;\n    height: 564px;\n}\n\n.modal_container :global(.ant-modal-content) {\n    padding: 0 0 16px 0 !important;\n}\n\n/* .modal_container :global(.ant-modal-close:hover) {\n    background-color: #fff;\n} */\n\n.main {\n    width: 100%;\n    height: 548px;\n    padding: 65px 52px 0 52px;\n}\n\n.header,\n.section,\n.section2 {\n    margin-bottom: 20px;\n}\n\n.header_title {\n    margin-bottom: 20px;\n    font-size: 30px;\n    font-weight: bold;\n    color: #1F1F1F;\n    text-align: center;\n}\n\n.header_explain {\n    font-size: 14px;\n    color: #1f1f1f;\n}\n\n.section_title,\n.section2_title {\n    margin-bottom: 15px;\n    font-weight: bold;\n    font-size: 14px;\n    color: #1f1f1f;\n}\n\n.section2_title {\n    margin-bottom: 5px;\n}\n\n.custom_textarea:hover,\n.custom_textarea:focus-within,\n.custom_textarea:focus {\n    border-color: #17a8b5;\n}\n\n/* 自定义滚动条 */\n.custom_textarea::-webkit-scrollbar {/*滚动条整体样式*/\n    -webkit-appearance: none;\n    width: 5px;\n    height: 5px;\n}\n\n.custom_textarea::-webkit-scrollbar-thumb {/*滚动条里面小方块*/\n    cursor: pointer;\n    border-radius: 5px;\n    background: #e9e9e9;\n    -webkit-transition: color .2s ease;\n    transition: color .2s ease;\n}\n\n.custom_textarea::-webkit-scrollbar-thumb:hover {\n    background: #e3e3e3;\n    cursor: default;\n}\n\n@keyframes shake {\n    0%, 100% {\n      transform: translateX(0);\n    }\n    10%, 30%, 50%, 70%, 90% {\n      transform: translateX(-2px);\n    }\n    20%, 40%, 60%, 80% {\n      transform: translateX(2px);\n    }\n}\n\n.feel_butn_box {\n    display: flex;\n    justify-content: space-evenly;\n    align-items: center;\n    width: 100%;\n    padding: 0 65px;\n}\n\n.feel_butn {\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 50px;\n    height: 50px;\n    cursor: pointer;\n}\n\n.feel_butn:not(.selected):hover {\n    animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;\n}\n\n.feel_butn_img {\n    width: 36px;\n    height: 36px;\n}\n\n.hook_img {\n    position: absolute;\n    bottom: -10px;\n    right: 0;\n    width: 32px;\n    height: 32px;\n}\n\n.footer {\n    width: 100%;\n    height: 48px;\n}\n\n.close_butn {\n    width: 24px;\n    height: 24px;\n    background: url('../../statics/modal_image_close.png') no-repeat center / 100% 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal_container": `ModalFeedback_modal_container__F71LN`,
	"main": `ModalFeedback_main__ISWhI`,
	"header": `ModalFeedback_header__vNGIG`,
	"section": `ModalFeedback_section__p21J7`,
	"section2": `ModalFeedback_section2__yWV8f`,
	"header_title": `ModalFeedback_header_title__OB-V+`,
	"header_explain": `ModalFeedback_header_explain__fbfSy`,
	"section_title": `ModalFeedback_section_title__ZA5Xa`,
	"section2_title": `ModalFeedback_section2_title__bdWes`,
	"custom_textarea": `ModalFeedback_custom_textarea__yUPlI`,
	"feel_butn_box": `ModalFeedback_feel_butn_box__fuMYm`,
	"feel_butn": `ModalFeedback_feel_butn__x5Ahz`,
	"selected": `ModalFeedback_selected__ZASmt`,
	"shake": `ModalFeedback_shake__T8GOB`,
	"feel_butn_img": `ModalFeedback_feel_butn_img__eDMj+`,
	"hook_img": `ModalFeedback_hook_img__6AGVm`,
	"footer": `ModalFeedback_footer__Gr9FB`,
	"close_butn": `ModalFeedback_close_butn__P1pXX`
};
export default ___CSS_LOADER_EXPORT___;
